import styled from 'styled-components';

export const TabsWrapper = styled.div`
  display: flex;
  padding: 0 32px;
  justify-content: center;
`;
